<template>
    <v-dialog
        :value="isOpen"
        max-width="600px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Wybierz komponent do dodania
                </h1>
            </v-card-title>

            <v-card-text>
                <v-autocomplete
                    v-model="selectedComponent"
                    :items="productComponents"
                    label="Komponenty"
                    placeholder="Wybierz komponent"
                    :filter="customComponentsFilter"
                    item-value="id"
                    return-object
                    outlined
                    hide-details
                >
                    <template #selection="data">
                        {{ data.item.name }}
                    </template>
                    <template #item="data">
                        {{ data.item.name }}
                    </template>
                </v-autocomplete>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Dodaj"
                    :disabled="!hasSelectedComponent"
                    @click="onSave"
                >
                    Dodaj
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { isEmpty } from 'lodash'

export default {
    name: 'AssignComponentDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        productComponents: {
            type: Array,
            default: null
        },
    },
    data() {
        return {
            selectedComponent: {}
        }
    },
    computed: {
        hasSelectedComponent() {
            return !isEmpty(this.selectedComponent)
        }
    },
    methods: {
        customComponentsFilter(item, queryText) {
            const name = item.name.toLowerCase(),
                search = queryText.toLowerCase()

            return name.indexOf(search) > -1
        },
        onSave() {
            this.onClose()
            this.$emit('on-save', this.selectedComponent)
        },
        onClose() {
            setTimeout(() => {
                this.selectedComponent = {}
            }, 500)
            this.$emit('on-close')
        },
    }
}
</script>

